import React from 'react'
import { StyledNavTrigger, StyledSubnavTriggerIcon } from './TheWestHeaderActions.styled'

export interface MenuActionProps {
    mainNavOpen: boolean
    children?: any
    openNavigation: () => void
    closeNavigation: () => void
}

export const MenuAction: React.FC<MenuActionProps> = ({
    mainNavOpen,
    openNavigation,
    closeNavigation,
    children = 'Menu',
}) => {
    const handleNavTrigger = () => {
        if (mainNavOpen) {
            closeNavigation()
        } else {
            openNavigation()
        }
    }

    return (
        <StyledNavTrigger type="button" onClick={handleNavTrigger}>
            <StyledSubnavTriggerIcon isActive={mainNavOpen} />
            {children}
        </StyledNavTrigger>
    )
}
